<template>
  <div class="grid grid-cols-[0.4fr_0.6fr] gap-36">
    <div class="col-start-1 col-end-2 self-center text-color-text-primary">
      <div class="flex items-end gap-2">
        <p class="font-serif text-xl font-bold text-theme-3">
          {{
            profile.discount
              ? priceDisplay(profile.discount.discount_price, lang, false)
              : priceDisplay(profile.price, lang, false)
          }}
        </p>

        <p v-if="profile.discount" class="pb-[0.2rem] font-serif text-sm font-bold text-theme-1 line-through">
          {{ priceDisplay(profile.price, lang, false) }}
        </p>
      </div>

      <div class="mt-4 flex items-center gap-2">
        <img :src="profile.seller_info.avatar" :alt="profile.seller_info.user_name" class="h-8 w-8 rounded-full" />

        <p class="font-normal">{{ profile.seller_info.user_name }}</p>
      </div>

      <h1 class="mt-3 font-serif text-4.5xl font-bold leading-normal">{{ profile.profiles[0].name }}</h1>

      <div
        v-if="profile.total_purchased >= MIN_PURCHASED_FOR_BADGE"
        class="flex items-center gap-2 text-theme-disabled-d"
      >
        <IconsVue.PurchasedIcon />

        <div class="text-sm">
          {{ $t("pages.profile-shop.profile-header.purchased", { count: profile.total_purchased }) }}
        </div>
      </div>

      <div class="mt-8">
        <TryBuyShopFlow :bundle="profile" :bundle-id="slug" />
      </div>
    </div>

    <div class="col-start-2 col-end-3">
      <div class="relative w-full overflow-hidden rounded-xl">
        <AspectRatio :ratio="16 / 9">
          <img class="h-full w-full object-cover" :src="profile.cover_photo" :alt="profile.profiles[0].name" />
        </AspectRatio>

        <IAITag
          v-if="profile.discount"
          class="absolute right-0 top-6 flex cursor-pointer items-center justify-center"
          size="small"
          variant="pink"
          rounded-side="left"
        >
          -{{ profile.discount.discount_percentage }}%
        </IAITag>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { IconsVue, IAITag } from "@/core-ui-vue";
import { IBundleDetailesResponse } from "@/features/sell-a-profile/services/api";
import { AspectRatio } from "radix-vue";
import TryBuyShopFlow from "@/features/profile-shop/components/profilePage/TryBuyShopFlow.vue";
import { MIN_PURCHASED_FOR_BADGE } from "@/features/profile-shop/utils";
import { getUnicodeBCP47 } from "@/locales/shared";
import { priceDisplay } from "@/features/pricing/components/IAIPrice/IAIPrice.vue";

defineProps<{
  profile: IBundleDetailesResponse;
  slug: string;
}>();
const lang = getUnicodeBCP47();
</script>
